module.exports = __webpack_public_path__ + "img/1 (46).4e819366.png";